// src/context/AuthContext.js
import React, { createContext, useEffect, useState, useContext } from "react"
import { onAuthStateChanged } from "firebase/auth"
import { auth, db } from "../firebase"
import { doc, getDoc } from "firebase/firestore"

const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [userData, setUserData] = useState(undefined) // ✅ changed from null
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async currentUser => {
      setUser(currentUser)

      if (currentUser) {
        const ref = doc(db, "users", currentUser.uid)
        const snap = await getDoc(ref)
        if (snap.exists()) {
          setUserData(snap.data())
        } else {
          setUserData(null) // ✅ explicitly handle no doc
        }
      } else {
        setUserData(null) // ✅ user logged out
      }

      setLoading(false)
    })

    return unsubscribe
  }, [])

  return (
    <AuthContext.Provider value={{ user, userData, loading }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
